import { TokenLogout } from 'API/Logout/logout';

import axios from 'axios';

const url = process.env.REACT_APP_POST_APPROVAL_URL;
const url2 = process.env.REACT_APP_BANKVERIFY_URL;

export const GetPaths = async (setData, setIsLoading, handleAlertOpen) => {
  try {
    setIsLoading(true);
    await axios
      .get(`${url}/logs_download/download_logs`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      });
  } catch (err) {
    setIsLoading(false);
    handleAlertOpen(err.response && err.response.data.error ? err.response.data.error : 'Something went wrong', 'error');
    TokenLogout(err);
    console.log(err);
  }
};

export const DownloadLogs = async (path, date, handleAlertOpen, setIsLoading) => {
  console.log('path', path);
  const today = new Date().toISOString().split('T')[0]; // e.g., "2025-05-02"
  const isDifferentDate = date !== today;
  try {
    setIsLoading(true);
    await axios
      .get(`${url2}test/${path.service_name}/${path.folder_name}/${path.file_name}${isDifferentDate ? `.${date}` : ''}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', path.file_name); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsLoading(false);
        handleAlertOpen('Logs Downloaded Successfully', 'success');
      });
  } catch (err) {
    setIsLoading(false);
    handleAlertOpen(err.response && err.response.data.error ? err.response.data.error : 'Something went wrong', 'error');
    TokenLogout(err);
    console.log(err);
  }
};

// For Delete User

export const DeleteUser = async (Data, handleAlertOpen, setIsLoading, setData) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/auth/remove_user_details`,
        {
          [Data.delete_by]: Data.delete_parameter,
          user_type: Data.user_type,
          pwd: 'pwd'
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        handleAlertOpen(res.data.message, 'success');
        setData({ delete_by: '', delete_parameter: '', user_type: '' });
      });
  } catch (err) {
    setIsLoading(false);
    handleAlertOpen(err.response && err.response.data.error ? err.response.data.error : 'Something went wrong', 'error');
    TokenLogout(err);
    console.log(err);
  } finally {
    setIsLoading(false);
  }
};

export const EmailServer = async (setIsloading, payload, password, setSuccess, setErrorMsg, refunction) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url2}email-server-csp-status/email_serve`,
        { ...payload },
        {
          headers: {
            Authorization: password
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            refunction();
          }, 1000);
        }
      })
      .catch((error) => {
        setErrorMsg(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
        TokenLogout(error);
        setIsloading(false);
      });
  } catch (error) {
    setErrorMsg(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    TokenLogout(error);
    setIsloading(false);
  }
};
